import React from 'react';
import { Switch, withStyles } from '@material-ui/core';

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: '2.85rem',
    height: '1.6rem',
    padding: 0,
  },
  switchBase: {
    [theme.breakpoints.down('xl')]: {
      padding: '0.25rem 0.3rem',
    },
    [theme.breakpoints.down('lg')]: {
      padding: '0.25rem 0.3rem',
    },
    [theme.breakpoints.down('md')]: {
      padding: '0.25rem 0.3rem',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0.25rem 0.3rem',
    },
    '&$checked': {
      transform: 'translateX(1.1rem)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#538fff',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: '1.1rem',
    height: '1.1rem',
    boxShadow: 'unset',
  },
  track: {
    borderRadius: '1rem',
    background: 'rgba(37, 40, 50, 0.3)',
    opacity: 1,
    // transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

function WarpSwitch({ checked, onChange, ...rest }) {
  return <IOSSwitch checked={checked} {...rest} onChange={onChange} />;
}

export { WarpSwitch };
